import { Component, OnInit } from '@angular/core';
// import { WindowRef } from './zoho-salesiq/WindowRef'
import { WindowRef } from './zoho-salesiq/WindowRef';
// import { ZohoSalesiqComponent } from './zoho-salesiq/zoho-salesiq.component';
@Component({
  selector: 'app-ecomm-support-center',
  templateUrl: './ecom-support-center.component.html',
  styleUrls: ['./ecom-support-center.component.scss'],
  providers: [WindowRef]
})
export class EcomSupportCenterComponent implements OnInit {
  window: any;
  constructor(private winRef: WindowRef) {
    this.window = winRef.nativeWindow;
  }

  ngOnInit() {
  }

  onCallClick(){
    document.location.href = 'tel:' + '1800-22-1333';
  }
  
  onChatStartClick() {
    this.window && this.window.$zoho.salesiq.floatwindow.visible('show');
  }

}
